const deviceKitNameExtended = {
  IQOS_24_CHARGER: "IQOS 2.4 CHARGER",
  IQOS_24_HOLDER: "IQOS 2.4 HOLDER",
  IQOS_24P_CHARGER: "IQOS 2.4+ CHARGER",
  IQOS_24P_HOLDER: "IQOS 2.4+ HOLDER",
  IQOS_3_CHARGER: "IQOS 3 CHARGER",
  IQOS_3_HOLDER: "IQOS 3 HOLDER",
  IQOS_3_DUO_CHARGER: "IQOS 3 DUO CHARGER",
  IQOS_3_DUO_HOLDER: "IQOS 3 DUO HOLDER",
  IQOS_3_MULTI: "IQOS 3 MULTI",
  IQOS_VEEV: "IQOS VEEV",
  IQOS_ILUMA_ONE: "IQOS ILUMA ONE",
  IQOS_ILUMA_PRIME_CHARGER: "IQOS ILUMA PRIME CHARGER",
  IQOS_ILUMA_PRIME_HOLDER: "IQOS ILUMA PRIME HOLDER",
  IQOS_ILUMA_CHARGER: "IQOS ILUMA CHARGER",
  IQOS_ILUMA_HOLDER: "IQOS ILUMA HOLDER",
  IQOS_ORIGINALS_ONE: "IQOS ORIGINALS ONE",
  IQOS_ARIANE: "IQOS ARIANE"
};

export default deviceKitNameExtended;
